export default {
  "content": "<path d=\"M13.207 16.793l-1.414 1.414-6-6 1.414-1.414 6 6z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.88 2.707a3 3 0 014.241 0l7.172 7.172a3 3 0 010 4.242l-7.172 7.172a3 3 0 01-4.242 0l-7.172-7.171a3 3 0 010-4.243L9.88 2.707zm2.827 1.414a1 1 0 00-1.414 0l-7.172 7.172a1 1 0 000 1.414l7.172 7.172a1 1 0 001.414 0l7.172-7.172a1 1 0 000-1.414l-7.172-7.172z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};